import { callBackendApi } from "../../../components/service/axios";

export const getUserGroupList = async (userGroupTypeId) => {
  return await callBackendApi("get", `/bff/user-groups/${userGroupTypeId}`);
};

export const publishUserGroup = async (userGroupId, userGroupType) => {
  return await callBackendApi("put", `/bff/user-groups/${userGroupId}/user-group-types/${userGroupType}/publish`, null, null, false);
};
